export const okayStatus = 'ic-okay'

export const amberStatus = 'ic-amber'

export const alertStatus = 'ic-alert'

